export default "/images/ryi-search-hint.png?a74c6fd49add9e89240b4d130488cdf0";